export const AUTOCOMPLETE = {
	CURRENT_PASSWORD: 'current-password',
	NEW_PASSWORD: 'new-password',
	USERNAME: 'username'
};
